import { useEffect } from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import PageHeader from "../components/PageHeader";
import ServicesGrid from "../components/sections/ServicesGrid";
import ReputationSpotlight from "../components/sections/ReputationSpotlight";
import { Reveal } from "../components/Reveal";
import { useConsultation } from "../context/ConsultationContext";
import { whatsappLink, DISCLAIMER } from "../data";

export default function Services() {
  const { openModal } = useConsultation();
  useEffect(() => {
    document.title = "Services — JOBLSX";
  }, []);

  return (
    <div>
      <PageHeader
        overline="What We Do"
        title="Services."
        subtitle="Professional, personalized support across account management, growth, audits, and technical guidance — always aligned with platform policies."
      />

      <section className="py-12 md:py-20">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <ServicesGrid />
        </div>
      </section>

      <section className="py-16 md:py-24 bg-[#0a0a0a]">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <ReputationSpotlight />
        </div>
      </section>

      <section className="pb-24 pt-8">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <Reveal>
            <div className="rounded-3xl border border-white/10 bg-white/[0.02] p-8 md:p-12">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Important Disclaimer</p>
              <p className="mt-3 max-w-3xl leading-relaxed text-slate-400">{DISCLAIMER}</p>
              <div className="mt-8 flex flex-col gap-4 sm:flex-row">
                <button
                  onClick={openModal}
                  className="flex items-center justify-center gap-2 rounded-full bg-blue-600 px-8 py-4 font-medium text-white shadow-[0_0_24px_rgba(37,99,235,0.4)] transition-all duration-300 hover:bg-blue-700 hover:-translate-y-1"
                  data-testid="services-book-button"
                >
                  Book Consultation <ArrowRight className="h-4 w-4" />
                </button>
                <a
                  href={whatsappLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/5 px-8 py-4 font-medium text-white transition-all duration-300 hover:bg-white/10 hover:-translate-y-1"
                  data-testid="services-whatsapp-button"
                >
                  <MessageCircle className="h-5 w-5" /> Ask on WhatsApp
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
